import React, { useRef } from 'react';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';
import emailjs from 'emailjs-com';
import swal from 'sweetalert';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_zwz6rvi',
        'template_1gpj7va',
        form.current,
        'iWK9lquFoM4RmQdT3'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
    swal('Thank you!', 'Your message was sent to my personal email', 'success');
  };

  return (
    <section id="contact" className="py-16 bg-aqua">
      <h5 className="text-title">Get in touch</h5>
      <h2 className="text-subtitle text-light">Contact Me!</h2>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12">
    
        <div className="flex flex-col gap-8">
          <article className="bg-primary border border-primary rounded-lg p-6 text-center transition duration-300 ease-in-out hover:bg-transparent hover:border-primary cursor-pointer">
            <MdOutlineEmail className="text-light text-3xl mb-4 md:ml-[21rem] ml-[10.5rem]" />
            <h4 className="text-xl mb-2">Email</h4>
            <h5 className="mb-4 text-light">roomi.molina@gmail.com</h5>
            <a
              href="mailto:roomi.molina@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="text-dark font-semibold hover:text-light"
            >
              Send a message
            </a>
          </article>

          <article className="bg-primary border border-primary rounded-lg p-6 text-center transition duration-300 ease-in-out hover:bg-transparent hover:border-primary cursor-pointer">
            <RiMessengerLine className="text-light text-3xl mb-4 md:ml-[21rem] ml-[10.5rem]" />
            <h4 className="text-xl mb-2">Messenger</h4>
            <h5 className="mb-4 text-light">Romina Molina</h5>
            <a
              href="https://www.messenger.com/t/100000050217947"
              target="_blank"
              rel="noreferrer"
              className="text-dark font-semibold hover:text-light"
            >
              Send a message
            </a>
          </article>

          <article className="bg-primary border border-primary rounded-lg p-6 text-center transition duration-300 ease-in-out hover:bg-transparent hover:border-primary cursor-pointer">
            <BsWhatsapp className="text-light text-3xl mb-4 md:ml-[21rem] ml-[10.5rem]" />
            <h4 className="text-xl mb-2">WhatsApp</h4>
            <h5 className="mb-4 text-light">Send me a whatsapp</h5>
            <a
              href="https://api.whatsapp.com/send?phone=543517889260"
              target="_blank"
              rel="noreferrer"
              className="text-dark font-semibold hover:text-light"
            >
              Send a message
            </a>
          </article>
        </div>

        {/* Contact Form */}
        <form
          ref={form}
          onSubmit={sendEmail}
          className="bg-light rounded-lg flex flex-col gap-6 p-12"
        >
          <input
            type="text"
            name="user_name"
            placeholder="Your Full Name"
            required
            className="p-4 bg-transparent border border-primary rounded-lg"
          />
          <input
            type="email"
            name="user_email"
            placeholder="Your Email"
            required
            className="p-4 bg-transparent border border-primary rounded-lg"
          />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
            className="p-4 bg-transparent border border-primary rounded-lg resize-none"
          ></textarea>
          <button
            type="submit"
            className="bg-primary text-light py-2 px-6 rounded-md border border-primary font-semibold text-center transition duration-300 ease-in-out hover:bg-transparent hover:text-primary"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
